@if (formState$ | async; as formState) {
  <wl-usage-questionnaire
    [rendering]="rendering"
    [formState]="formState"
  ></wl-usage-questionnaire>
}
